import { format, parseISO } from 'date-fns'

const localizedFormat = 'dd/MM/y'

function formatDate (dateStr, formatType = localizedFormat) {
  if (!dateStr) { return null }
  return format(parseISO(dateStr), formatType)
}
export {
  formatDate
}
